import type { ColumnDef, ColumnSort, OnChangeFn, SortingState } from "@tanstack/react-table"
import { getCoreRowModel } from "@tanstack/react-table"
import type { FC, Ref } from "react"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"
import { type WarehouseShelving } from "@/graphql/codegen/graphql"

interface WarehouseShelvingTableProps {
  data: WarehouseShelving[]
  fetching: boolean
  columns: ColumnDef<WarehouseShelving>[]
  sorting: ColumnSort[]
  error?: Error
  tableContainerRef?: Ref<HTMLDivElement>
  onSortingChange: OnChangeFn<SortingState>
  onScroll: () => void
}

export const WarehouseShelvingTable: FC<WarehouseShelvingTableProps> = ({
  data,
  fetching,
  columns,
  sorting,
  error,
  tableContainerRef,
  onSortingChange,
  onScroll,
}) => {
  return (
    <AerosBaseTable
      features={{
        table: {
          stickyHeader: true,
        },
        tanstackOptions: {
          data,
          columns,
          state: {
            sorting,
            isLoading: fetching,
          },
          onSortingChange,
          manualSorting: true,
          enableSorting: true,
          enableMultiSort: false,
          enableSortingRemoval: false,
          getCoreRowModel: getCoreRowModel(),
        },
      }}
      error={error}
      slotProps={{
        container: {
          ref: tableContainerRef,
          onScroll,
        },
        bodyRow: {
          className: "hover:bg-primary-100 cursor-pointer",
        },
      }}
      noDataMessage='No warehouse shelving found'
    />
  )
}

export default WarehouseShelvingTable
